import { render } from "./Copy.vue?vue&type=template&id=fa1f2dfa"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Copy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa1f2dfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa1f2dfa', __exports__)) {
    api.reload('fa1f2dfa', __exports__)
  }
  
  module.hot.accept("./Copy.vue?vue&type=template&id=fa1f2dfa", () => {
    api.rerender('fa1f2dfa', render)
  })

}


export default __exports__